import { Carousel } from 'antd';
import { flatten } from 'lodash';
import React, { isValidElement } from 'react';

import { CarouselImageContainerStyled, CarouselImageStyled, UserAvatarContainerStyled } from './styled';
import { IAvatarSizes } from './types';

const CardAvatar: React.FC<{
  avatar?: any;
  originAvatar?: string | string[];
  className?: string;
  avatarSizes?: IAvatarSizes;
  isMobile?: boolean;
}> = ({ avatar, originAvatar, className, avatarSizes, isMobile }) => (
  <UserAvatarContainerStyled
    $isMobile={isMobile}
    style={{ ...avatarSizes, background: avatar && !isValidElement(avatar) ? '#003366' : undefined }}
    className={`${className} custom-card-avatar-container`}>
    {avatar && !isValidElement(avatar) && (
      <Carousel style={{ marginBottom: 0 }} className='gx-data-card-carousel'>
        {flatten([avatar]).map((src, index) => (
          <CarouselImageContainerStyled
            href={flatten([originAvatar])[index] || avatar[index]}
            target='_blank'
            key={src}>
            <CarouselImageStyled
              alt='avatar'
              src={src}
              className='gx-object-cover'
              style={{ height: avatarSizes?.height || '100%' }}
            />
          </CarouselImageContainerStyled>
        ))}
      </Carousel>
    )}
    {avatar && isValidElement(avatar) && avatar}
    {/* <img alt='avatar' src={avatar} className='gx-object-cover' /> */}
  </UserAvatarContainerStyled>
);
export default React.memo(CardAvatar);
